import AllForms from "src/Pages/forms/allforms/AllForms";

function CustomerForms({ customerId }) {
  return <AllForms hideControls customerId={customerId} />;
}

export default CustomerForms;
